    <div class="modal-header">
        <h4 class="modal-title">Timer Kundenr.: </h4>
        <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
    </div>

    <div class="modal-body">
        <div class="table__viewport">
            <table class="table table-hover table-striped table-sm table-frame__body" >
                <thead class="fixed-top position-fixed position-sticky">
                    <tr>
                        <th colspan="5">Timer</th>
                    </tr>
                    <tr>
                        <th class="text-nowrap">Dato</th>
                        <th class="text-nowrap">Medarbejder</th>
                        <th class="text-nowrap">Beskrivelse</th>
                        <th class="text-nowrap text-end">Timer</th>
                        <th class="text-nowrap text-end">Beløb</th>
                    </tr>
                </thead>

                <tbody>
                <tr *ngFor="let item of brugtTimer">
                    <td>{{ item.date | date:'dd-MM-yyyy' }}</td>
                    <td>{{ item.medarbejder }}</td>
                    <td>{{ item.beskrivelse }} </td>
                    <td class="text-end">{{ item.timer | time}}</td>
                    <td class="text-end">{{ item.beloeb | currency:'DKK':'':'1.0-0':'da'}}</td>
                </tr>
                </tbody>

                <tfoot class="fixed-bottom position-fixed position-sticky">
                    <tr>
                        <th>Total</th>
                        <th></th>
                        <th></th>
                        <th class="text-end">{{hoursTotal() | time}}</th>
                        <th class="text-end">{{amountTotal(brugtTimer) | currency:'DKK':'':'1.0-0':'da'}}</th>
                    </tr>
                </tfoot>
            </table>

            <table class="table table-hover table-striped table-sm table-frame__body" >
                <thead class="fixed-top position-fixed position-sticky">
                <tr>
                    <th colspan="4">Kronekladde</th>
                </tr>
                <tr>
                    <th class="text-nowrap">Dato</th>
                    <th class="text-nowrap">Medarbejder</th>
                    <th class="text-nowrap">Beskrivelse</th>
                    <th class="text-nowrap text-end">Beløb</th>
                </tr>
                </thead>

                <tbody>
                <tr *ngFor="let item of brugtKr">
                    <td>{{ item.date | date:'dd-MM-yyyy' }}</td>
                    <td>{{ item.medarbejder }}</td>
                    <td>{{ item.beskrivelse }} </td>
                    <td class="text-end">{{ item.beloeb | currency:'DKK':'':'1.0-0':'da'}}</td>
                </tr>
                </tbody>

                <tfoot class="fixed-bottom position-fixed position-sticky">
                <tr>
                    <th>Total</th>
                    <th></th>
                    <th></th>
                    <th class="text-end">{{amountTotal(brugtKr) | currency:'DKK':'':'1.0-0':'da'}}</th>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
